import React from "react";
import { Modal } from "react-bootstrap";

import RoundedButton from "../buttons/RoundedButton";

const ConfirmationModal = (props) => {
  const { onCancel, onConfirm, message = "", show = true } = props;

  return (
    <Modal
      centered
      show={show}
      onHide={onCancel}
      className="confirmation-modal"
    >
      <Modal.Header className="align-items-center justify-content-between confirmation-modal-header">
        <div className="confirmation-modal-heading">Confirm</div>
      </Modal.Header>
      <Modal.Body className="">{message}</Modal.Body>
      <Modal.Footer>
        <RoundedButton onClick={onConfirm}>Confirm</RoundedButton>
        <RoundedButton variant="outlined-blue" onClick={onCancel}>
          Cancel
        </RoundedButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
